import { toast } from "react-toastify";
import exportFromBlob from "helpers/export-from-blob";
import { getResumeFile, downloadResumeFile } from "./requests";

export const fetchResumeFile = (fileId, callback) => dispatch => {
    getResumeFile(fileId)
        .then(response => {
            if (callback) callback(response.data);
        })
        .catch(error => {
            console.error("Error fetching resume file:", error);
            toast("Failed to load resume file", { type: toast.TYPE.ERROR });
            if (callback) callback(null);
        });
};

export const downloadResume = (fileId, filename = "resume.pdf") => dispatch => {
    downloadResumeFile(fileId)
        .then(response => {
            exportFromBlob(response.data, filename);
            toast("Resume downloaded successfully", { type: toast.TYPE.SUCCESS });
        })
        .catch(error => {
            console.error("Error downloading resume:", error);
            toast("Failed to download resume", { type: toast.TYPE.ERROR });
        });
};
